import { Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { PageLayoutService } from '../../../services/page-layout.service';
import { HsgEntityAdminPage } from './entity-admin.component';
import { MappingEntityInterface } from './mapping-entity.interface';
import { MappingFilterEntityServiceInterface } from './mapping-filter-entity-service.interface';
import { MappingFilterEntityInterface } from './mapping-filter-entity.interface';
import { MappingServiceInterface } from './mapping-service.interface';
//import { HeaderButtonEntity } from './section-header-button.entity';

@Component({
  selector: 'hhsg-mapping',
  templateUrl: './mapping-page.component.html',
  styleUrls: ['./mapping-page.component.scss']
})


export class MappingPageComponent extends HsgEntityAdminPage implements OnDestroy, OnInit {
  @Input() entityName: string;
  @Input() unmappedEntityName: string = '';
  @Input() pageName: string;
  @Input() searchByText: string;
  @Input() sortOptions: string[];
  @Input() mappingService: MappingServiceInterface;
  @Input() getDisplayName: Function;
  @Input() getDisplayTitle: Function;
  @Input() isSelected: Function;
  @Input() mappingForm: NgForm;
  @Input() mappingDetailTemplate: TemplateRef<HTMLElement>;
  @Input() legendTemplate: TemplateRef<HTMLElement>;
  @Input() typeDropdownTemplate: TemplateRef<HTMLElement>;
  @Input() mappingDialogTemplate: TemplateRef<HTMLElement>;
  @Input() buttonTemplate: TemplateRef<HTMLElement>;
  @Input() mappingFilterEntityService: MappingFilterEntityServiceInterface;
  @Input() hasEntityFilter: boolean;
  @Input() filterEntityDisplayName: string;
  @Input() isReadOnly: boolean;
  @Input() showCloseLink: boolean;
  @Input() isDefaultOptionRequiredInFilterEntities: boolean = false;
  @Input() isWarningPopupRequiredForUnsavedChanges: boolean = false;
  @Input() filterEntityDefaultOptionText: string;
  //@Input() headerButton: HeaderButtonEntity;
  @Input() entityType: string;
  @Input() customConsumerCss: string = '';
  @Input() rhsHeaderTextMaxLength: number = 0;
  @Input() isDefaultStamping: boolean = true;
  @Input() isLegendRequired: boolean = false;
  @Input() warnBeforeSave: boolean = false;
  @Input() saveWarningMessage: string = "";
  @Input() isDefaultMappingStatus: boolean = true;
  @Input() mappingStatusTemplate: TemplateRef<HTMLElement>;
  @Input() refreshSelectionAfterSave: boolean = false;
  @Input() hasfooter: boolean = true;
  @Input() menuWidth: string;
  @Input() hasLegends: boolean;

  @Input() set consumerFilterEntityId(value: number) {
    this.filterEntityId = value;
  };

  @Output() onHeaderButtonClick: EventEmitter<any> = new EventEmitter();
  @Output() onSelectionEvent: EventEmitter<string> = new EventEmitter<string>();
  @Output() isActiveEvent: EventEmitter<any> = new EventEmitter();
  @Output() onDialogSaveEvent: EventEmitter<any> = new EventEmitter();

  @ViewChild('adminListContainer') public adminListContainer: ElementRef;

  mappings: MappingEntityInterface[];
  filterEntities: MappingFilterEntityInterface[];
  filterEntityId: number = -1;
  unmappedItemCount: number = 0;
  unmappedOnly: boolean;
  private saveMappingSubject: Subject<any> = new Subject();
  adminContainerCss = "admin-main";
  private _dirty = false;
  confirmUnsavedModalActive: boolean = false;
  acceptEventFunction: Function;
  rejectEventFunction: Function;
  warnBeforeSaveAcceptEventFunction: () => any;
  warnBeforeSaveRejectEventFunction: () => any;
  confirmSaveBeforeWarningModalActive: boolean = false;
  navigateRoute: Subject<boolean> = new Subject<boolean>();
  isSaveError: boolean = false;
  testsort: string = '';
  
  constructor(
    protected _pageLayout: PageLayoutService) {
    super(_pageLayout);

    this.saveMappingSubject
      .pipe(debounceTime(500))
      .subscribe(async () => {
        await this.saveMapping();
      }
      );
  }

  ngOnDestroy() {
    super.cleanUp();
  }

  async ngOnInit() {
    this.unmappedOnly = false;

    if (this.rhsHeaderTextMaxLength > 0) {
      this.adminActionLabelMaxLength = this.rhsHeaderTextMaxLength;
    }
   
    
    super.initialize(
      this.pageName,
      this.sortOptions,
      () => this.setCurrentSelectionLabel(),
      () => { return "Remove"; });
      
      if (this.hasEntityFilter) {
        await this.getFilterEntities();
      }
      
    
    this.adminContainerCss = (this.customConsumerCss) ? this.adminContainerCss : this.adminContainerCss + ' ' + this.customConsumerCss;

  }

  protected async adminActionSave(): Promise<any> {
   // this.saveMappingSubject.next();
  }

  protected async saveMapping(): Promise<any> {
    if (!this.selection) {
      return;
    }

    if (this.warnBeforeSave) {
      this.warnBeforeSaveMapping(() => {
        this.saveMappingInfo()
      })
    }
    else {
      this.saveMappingInfo()
    }
  }

  async saveMappingInfo(): Promise<any> {
    let loadingSections = [this.adminListLoadingSection, this.adminActionLoadingSection];
    this.setLoading(loadingSections, true);

    let result = await this.mappingService.saveMapping(this.selection);
    this.unmappedItemCount = await this.mappingService.getUnmappedItemCount(this.filterEntityId);
    if (this.unmappedItemCount === 0) {
      this.unmappedOnly = false;
    }
    if (result && result.isMapped && !result.errorMessage) {
      if (this.refreshSelectionAfterSave) {
        this.selection = result;
        super.limitAdminActionLabel();
      }
      await super.refreshAdminList(true, true);

      this.resetForm();
    }
    else {
      this.isSaveError = true;
      super.setErrorMessage(result.errorMessage);
    }

    this.setLoading(loadingSections, false);
  }

  protected async adminListAppend(): Promise<any> {
    let result = await this.mappingService.getItemsToMap(
      false,
      this.offset,
      this.itemsPerPage,
      this.searchText,
      this.selectedFilter,
      this.getSortOrderString(),
      this.unmappedOnly,
      this.filterEntityId);

    this.mappings = this.mappings.concat(result);
  }

  protected async adminActionRefresh(): Promise<any> {
    super.setErrorMessage("");
    this.isSaveError = false;
    if (this.onSelectionEvent) {
      this.onSelectionEvent.emit('onSelection');
    }
  }

  protected async adminListRefresh(newFirst: boolean): Promise<any> {
    let result = await this.mappingService.getItemsToMap(
      newFirst,
      this.offset,
      this.itemsPerPage,
      this.searchText,
      this.selectedFilter,
      this.getSortOrderString(),
      this.unmappedOnly,
      this.filterEntityId);
    this.mappings = result;
    this.resetForm();

    this.unmappedItemCount = await this.mappingService.getUnmappedItemCount(this.filterEntityId);

    return result;
  }

  override onCancel() {
    this.warnIfDirty(() => {
      super.onCancel();
      this.resetForm();
    });
  }

  override async onSearchKey(event: any) {
    let searchText = this.searchText;
    this.warnIfDirty(() => {
      super.onSearchKey(event);
    }, () => {
      this.searchText = searchText;
    });
  }

  override onSortTypesDropDownChanged(event: any) {
    let previousSelectedFilter = this.selectedFilter;
    this.testsort = this.selectedFilter;
    this.warnIfDirty(() => {
      super.onSortTypesDropDownChanged(event);
    }, () => {
      this.selectedFilter = previousSelectedFilter;
    });
  }

  override onChangeSortOrder() {
    this.warnIfDirty(() => {
      super.onChangeSortOrder();
    });
  }

  async toggleUnmappedOnly() {
    this.warnIfDirty(() => {
      this.unmappedOnly = !this.unmappedOnly;
      super.refreshAdminList(false, false);
    });
  }

  resetForm() {
    if (!this.mappingForm) {
      return;
    }

    Object.keys(this.mappingForm.controls).forEach(control => {
      this.mappingForm.controls[control].markAsPristine();
    });

    this._dirty = false;
  }

  setCurrentSelectionLabel(): string {
    if (!this.selection) {
      return "";
    }
    return this.getDisplayName(this.selection);
  }

  getIsActive(mapping: MappingEntityInterface): boolean {
    if (this.isSelected != null) {
      return this.isSelected(mapping, this.selection);
    }
    return this.selection != undefined && this.selection != null && mapping.id == this.selection.id;
  }

  isSaveButtonDisabled(): boolean {
    return this.isReadOnly || !this.mappingForm || !this.mappingForm.form.valid || !this.mappingForm.dirty || !this.saveButtonEnabled;
  }

  override onSelection(selected: any) {
    this.warnIfDirty(() => {
      super.onSelection(selected);
      this.isSaveError = false;
      if (this.mappingForm && this.mappingForm.dirty) {
        this.resetForm();
      }
    });
  }

  onHeaderButtonClicked() {
    this.warnIfDirty(() => {
      this.onHeaderButtonClick.emit(this);
      this.adminListContainer.nativeElement.scrollTop = 0;
    });
  }

  protected isAddButtonEnabled(page: string): boolean {
    return false;
  }

  protected isDeleteButtonEnabled(page: string): boolean {
    return false;
  }

  protected isSaveButtonEnabled(page: string): boolean {
    return true;
  }

  beforeFilterEntityDropDownChanged(event) {
    let previousFilterEntityId = this.filterEntityId;
    this.warnIfDirty(() => {
      this.onFilterEntityDropDownChanged(event);
    }, () => {
      this.filterEntityId = previousFilterEntityId;
    });
  }

  async onFilterEntityDropDownChanged(event: any) {
    this.unmappedOnly = false;
    this.filterEntityId = event;
    sessionStorage.setItem('RecentSelectedFilterEntityId', this.filterEntityId.toString());
    await super.refreshAdminList(false, false);
  }

  async getFilterEntities() {
    this.filterEntities = await this.mappingFilterEntityService.getFilterEntities(this.isDefaultOptionRequiredInFilterEntities);
    console.log(this.filterEntities.length);
    if (this.filterEntities) {
      let filterEntity = this.filterEntities.some(s => s.id == this.filterEntityId);
      if (!filterEntity && !this.isDefaultOptionRequiredInFilterEntities)
        this.filterEntityId = -1;

      if (this.isDefaultOptionRequiredInFilterEntities && this.filterEntityId == -1)
        this.filterEntityId = this.filterEntities.filter(s => s.isDefaultAccount)[0].id;
    }

    console.log('check--' + this.filterEntityId);
  }

  getEntityDisplayName() {
    return this.entityType != null && this.entityType != undefined && this.entityType != "" ?
      this.entityType + ' - ' + this.entityName : this.entityName;
  }

  //This function displays warning popup if there are unsaved changes and user tries to do some other activity on UI.
  warnIfDirty(unsavedFunction: () => void, rejectEventFunction?: () => void) {
    if (this.isWarningPopupRequiredForUnsavedChanges && this.isFormDirty) {
      this.confirmUnsavedModalActive = true;
      this.acceptEventFunction = () => {
        unsavedFunction();
        this.confirmUnsavedModalActive = false;
      };
      this.rejectEventFunction = () => {
        this.confirmUnsavedModalActive = false;
        if (rejectEventFunction)
          rejectEventFunction();
      }
    }
    else {
      unsavedFunction();
      this.confirmUnsavedModalActive = false;
    }
  }

  get isFormDirty(): boolean {
    return this._dirty || (this.mappingForm && this.mappingForm.dirty);
  }

  warnBeforeSaveMapping(acceptEventFunction: () => void, rejectEventFunction?: () => void) {
    if (!this.warnBeforeSave) return;

    this.confirmSaveBeforeWarningModalActive = true;
    this.warnBeforeSaveAcceptEventFunction = () => {
      acceptEventFunction();
      this.confirmSaveBeforeWarningModalActive = false;
    };
    this.warnBeforeSaveRejectEventFunction = () => {
      this.confirmSaveBeforeWarningModalActive = false;
      if (rejectEventFunction)
        rejectEventFunction();
    }
  }

  //This function will be called before route change to display warning popup if there are any unsaved changes in UI. In routing module of child apps, a Route Guard service needs to be created and passed in 'canDeactivate' property which will call this function.
  canDeactivate(): boolean | Observable<boolean> | Promise<boolean> {
    if (this.isWarningPopupRequiredForUnsavedChanges && this.isFormDirty) {
      this.warnIfDirty(() => {
        this.navigateRoute.next(true);
      });
      return this.navigateRoute;
    }
    else
      return true;
  }

  @HostListener("window:beforeunload", ["$event"])
  unloadHandler(event: Event) {
    if (this.isWarningPopupRequiredForUnsavedChanges && this.isFormDirty) {
      event.returnValue = true; // stay on same page
    }
  }

  onDialogSave(){
    this.onDialogSaveEvent.emit();
  }
}
